import { TweenMax } from 'gsap';
import { GameAudio } from '../../../../Config/Audio';
import Core from '../../../../Core/Core';
import SoundManager from '../../../../Sound/SoundManager';
import { createOutlineText } from '../../../../Utils/Utils';
import { TileGoldMatch } from '../../../Animations/TileGoldMatch';
import { ProgressBar } from '../../../Shared/ProgressBar';

export class MissionMilestoneBar extends ProgressBar {
    private m1Sprite: PIXI.Sprite;
    private m2Sprite: PIXI.Sprite;

    constructor(initialProgress: number) {
        super(initialProgress);

        // icons ...coin, coins, present
        const m1 = new PIXI.Sprite(PIXI.utils.TextureCache['commonui/reward-coin01']);
        const m2 = new PIXI.Sprite(PIXI.utils.TextureCache['commonui/reward-coin02']);
        const m3 = new PIXI.Sprite(PIXI.utils.TextureCache['mapui/dailygoals-giftbox']);

        m1.scale.set(0.8);
        m2.scale.set(0.8);

        m1.anchor.set(0.5);
        m2.anchor.set(0.5);
        m3.anchor.set(0.5);

        m1.x = this.progressBar.width * 0.3;
        m2.x = this.progressBar.width * 0.6;
        m3.x = this.progressBar.width * 0.94;

        const rewardText = createOutlineText(
            Core.local.getText('GoalCompletionReward'),
            new PIXI.Rectangle(
                this.progressBar.width * 0.5,
                -this.progressBar.height * 1.35,
                this.progressBar.width * 0.9,
                this.progressBar.height * 0.4
            ),
            'Baloo',
            28,
            28,
            0xffffff,
            0x991f33
        );
        rewardText.anchor.set(0.5);

        this.addChild(rewardText, m1, m2, m3);

        this.m1Sprite = m1;
        this.m2Sprite = m2;
    }

    public playCoinAnimation(milestone: number, coins: number): void {
        SoundManager.playSound(GameAudio.MATCH_GOLD);
        const anim = new TileGoldMatch();

        const positionSprite = milestone === 1 ? this.m1Sprite : this.m2Sprite;
        anim.position.set(positionSprite.x, positionSprite.y);
        this.addChild(anim);

        const text = createOutlineText(
            `+${coins}\ncoins`,
            new PIXI.Rectangle(positionSprite.x, positionSprite.y, 100, 50),
            'Baloo',
            24,
            24,
            0xffffff,
            0x006eba,
            4
        );
        this.addChild(text);

        TweenMax.to(text, 0.5, {
            y: 5,
            onComplete: () => {
                this.removeChild(text);
                text.destroy();
            },
        });
    }
}
